<template>
	<div class="picker deprecated-select input" :class="{'is-focus': isFocused, 'is-read-only': readonly}">
		<template v-if="readonly">{{ value || "&nbsp;" }}</template>
		<ElSelect
			v-else
			:id="id"
			ref="select"
			v-model="internalValue"
			v-bind="$attrs"
			:placeholder="placeholder"
			default-first-option
			:filterable="filterable"
			:filter-match="filterMatch"
			:popper-class="`deprecated-select${popperClass ? ' ' + popperClass : ''}`"
			:allow-create="allowOther"
			no-data-text=" "
			no-match-text="No data was found."
			@focus="handleFocus"
			@blur="handleBlur"
			@change="handleChange"
		>
			<ElOption v-for="item in options" :key="item.value" :value="item.value" :label="item.displayValue"></ElOption>
			<template #suffix>
				<slot name="suffix" @click="handleIconClick" @mousedown="handleIconMousedown">
					<Inline svg="chevron-down" />
				</slot>
			</template>
		</ElSelect>
	</div>
</template>

<script>
	import { Select, Option } from '@cognitoforms/element-ui';
	import focus from '../../mixins/focus.ts';

	export default {
		name: 'CSelect',
		components: {
			ElSelect: Select,
			ElOption: Option
		},
		mixins: [focus],
		inheritAttrs: false,
		model: {
			prop: 'value',
			event: 'change'
		},
		props: {
			value: {
				type: String,
				default: null
			},
			readonly: Boolean,
			placeholder: {
				type: String,
				default: null
			},
			options: {
				// Array of { value, displayValue }
				type: Array,
				default: null
			},
			id: {
				type: String,
				default: null
			},
			filterable: {
				type: Boolean,
				default: false
			},
			filterMatch: {
				type: String,
				default: 'anywhere'
			},
			allowOther: {
				type: Boolean,
				default: false
			},
			popperClass: {
				type: String,
				default: null
			}
		},
		data: function () {
			return {
				internalValue: this.value,
				oldWindowWidth: null
			};
		},
		watch: {
			value: function (valueProp) {
				this.internalValue = valueProp;
				this.$emit('change', this.internalValue);
			}
		},
		mounted () {
			this.oldWindowWidth = window.innerWidth;
			window.addEventListener('resize', this.handleResize);
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.handleResize);
		},
		methods: {
			handleChange(value, prevValue) {
				this.internalValue = value;
				this.$emit('change', value, prevValue);
			},
			handleNativeChange(ev) {
				const value = ev.target.value;
				this.internalValue = value;
				this.$emit('change', value, ev);
			},
			handleIconMousedown(e) {
				// prevent handleBlur from being called as a result of clicking the chevron
				e.preventDefault();
			},
			handleIconClick(e) {
				// toggle menu
				this.$refs.select.visible = !this.$refs.select.visible;
				e.stopPropagation();

				// keep focus on select regardless
				this.isFocus = true;
				this.$refs.select.$el.querySelector('input').focus();
			},
			handleResize() {
				// Hide the dropdown on window WIDTH resize, this hides the dropdown at the start of the resizing event

				const windowWidth = window.innerWidth;
				if (windowWidth !== this.oldWindowWidth) {
					this.oldWindowWidth = windowWidth;

					if (this.$refs.select)
						this.$refs.select.blur();
				}
			}
		}
	};
</script>

<style lang="scss" src="@cognitoforms/styles/app/inputs.scss"></style>
<style lang="scss" src="@cognitoforms/styles/global/_scrollbar.scss"></style>

<style lang="scss">
.deprecated-select {

	.el-select {

		.is-focus {

			.el-input__inner {
				border-bottom-left-radius: 0;
				border-bottom-right-radius: 0;
			}

			.i-chevron-down {
				transform: scaleY(-1);
			}
		}

		.el-input__inner {
			height: initial !important;
			padding-right: calc(1em + 16px);
			cursor: pointer;
			text-overflow: ellipsis;
		}

		.el-input {
			display: flex;
			position: relative;
			align-items: center;

			> .el-input__suffix {
				display: flex; // make us of Flexbox
				position: absolute;
				bottom: 0;
				right: 5px;
				top: 0;
				z-index: $z2;
				align-items: center; // does vertically center the desired content
				justify-content: center; // horizontally centers single line items
				margin-top: auto;
				margin-bottom: auto;
				text-align: center; // optional, but helps horizontally center text that breaks into multiple lines
				pointer-events: none;
			}

			.i-chevron-down {
				width: 14.4px;
				margin-right: 5px;

				&::before,
				&::after {
					background-color: var(--shade-5);
				}

				&:hover {
					cursor: pointer;
				}
			}
		}
	}

	.el-input__suffix-inner {
		display: flex;
	}

	&.el-select-dropdown {
		max-width: calc(100% - 10px);
		border: 1px solid var(--border-primary);
	}

	.el-select-dropdown {

		&__list {
			background-color: white;
			margin: 0;
			padding: 0;
			list-style: none;
		}

		&__item {
			position: relative;
			margin-bottom: 0;
			padding: .75em .85em;
			cursor: pointer;

			@include nowrap;

			li + li {
				margin-top: 0;
			}

			&.hover {
				background: var(--bg-hovered);
			}

			&.selected {
				background: var(--bg-selected);
			}
		}

		&__empty {
			background-color: white;
			margin: 0;
			padding: .75em .85em;
			text-align: center;
		}
	}

	.el-scrollbar__wrap {
		max-height: calc(50vh - 40px);
	}
}
</style>